import { useState, useCallback, useEffect } from 'react';

// Custom hook to manage widget expansion state independently
// This prevents expansion state from being lost during re-renders
export const useWidgetExpansion = (widgetId: string) => {
  const expansionKey = `widget_expanded_${widgetId}`;
  
  // Initialize from sessionStorage
  const [isExpanded, setIsExpanded] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = sessionStorage.getItem(expansionKey);
      return stored === 'true';
    }
    return false;
  });
  
  // Persist to sessionStorage whenever it changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(expansionKey, String(isExpanded));
    }
  }, [isExpanded, expansionKey]);
  
  const toggleExpanded = useCallback(() => {
    setIsExpanded(prev => !prev);
  }, []);
  
  const setExpanded = useCallback((value: boolean) => {
    setIsExpanded(value);
  }, []);
  
  return {
    isExpanded,
    toggleExpanded,
    setExpanded
  };
};